module.exports = __webpack_public_path__ + "static/media/dontcopy4.7091b310.gif";